import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { InnerSearch } from "../components/search/InnerSearch";
import { RealtedVideo } from "../components/realtedVideo/RealtedVideo";
import { AskedQuestions } from "../help_support/components/AskedQuestions";
import { useLocation } from "react-router-dom";

export const SearchList = () => {
  const apiBaseURL = process.env.REACT_APP_API_URL || window.location.origin;

  const [faqListData, setFaqListData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const { state } = useLocation();
  const searchIDs = state?.detailsIDs ?? {};
  const searchValue = searchIDs?.searchValue ?? "";

  const innerSearch = {
    pageName: "Search Results for ",
    backSteps: "",
    breadcrumb: [
      {
        label: "Home",
        url: "/VZYSupport/helpSupport",
      },
      { label: "Search" },
      { label: searchValue || "Results" },
    ],
  };

  const fetchFAQList = useCallback(async () => {
    if (!searchValue) {
      setFaqListData([]);
      return;
    }

    setLoading(true);
    setError("");

    try {
      const response = await axios.get(
        `${apiBaseURL}/api/VZYHelpSupport/search`,
        {
          params: {
            q: searchValue,
            language: "en",
            limit: 5,
          },
        },
      );

      const suggestions = Array.isArray(
        response?.data?.result?.data?.suggestions,
      )
        ? response.data.result.data.suggestions
        : [];

      const result = suggestions.map((item) => ({
        contentTypeID: 0,
        contentCode: item?.content_code ?? "",
        contentTitle: item?.text ?? "",
        type: item?.type ?? "",
        categoryID: 0,
        displayOrder: 0,
      }));

      setFaqListData(result);
    } catch (err) {
      console.error("FAQ search failed:", err);
      setError("Failed to load FAQs.");
      setFaqListData([]);
    } finally {
      setLoading(false);
    }
  }, [apiBaseURL, searchValue]);

  useEffect(() => {
    fetchFAQList();
  }, [fetchFAQList]);

  return (
    <>
      <InnerSearch innerSearch={innerSearch} />

      <section className="inner-page-details">
        <div className="container">
          <div className="row">
            <div className="col-md-9">
              <div className="title-filter-row">
                <h4 className="detail-page-title">
                  Frequently Asked Questions
                </h4>
              </div>

              <div className="faq-accordian">
                {loading && <p className="text-center mt-2">Loading...</p>}

                {!loading && error && <p className="text-danger">{error}</p>}

                {!loading && !error && faqListData.length === 0 && (
                  <p>Data not found.</p>
                )}

                {!loading && !error && faqListData.length > 0 && (
                  <AskedQuestions faqListData={faqListData} />
                )}
              </div>
            </div>

            <div className="col-md-3">
              <h4 className="detail-page-sidebar-title">Related Videos</h4>
              <div>
                <RealtedVideo />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
